"use client"

import { useEffect } from "react"
import Image from "next/image"
import {
  Avatar,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from "@heroui/react"

import extensionmobile from "@/assets/extensionmobile.png"
import extensionmodalimg from "@/assets/extensionmodalimg.png"
import halfstar from "@/assets/halfstar.png"
import star from "@/assets/icons/star.svg"
import { GoogleStoreLink } from "@/components/google-store-link"
import { useExt } from "@/hooks/use-ext"
import extension from "@/public/extension.png"

export default function PageClient() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const isReady = useExt()

  useEffect(() => {
    if (!isReady) {
      const storage_value = localStorage.getItem("is-extension-modal-opened")
      if (storage_value !== "true") {
        onOpen()
      }
    }
  }, [isReady, onOpen])

  useEffect(() => {
    if (isOpen) {
      localStorage.setItem("is-extension-modal-opened", "true")
    }
  }, [isOpen])

  const handleClose = () => {
    onClose()
  }

  if (isReady) {
    return null
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isDismissable={false}
      hideCloseButton
      size={"sm"}
      classNames={{
        base: "sm:max-w-[440px] max-w-[330px]",
      }}
    >
      <ModalContent
        className="overflow-visible"
        style={{
          background:
            "linear-gradient(180deg, rgba(210, 253, 255, 0.84) -7.97%, rgba(255, 255, 255, 0.00) 79.31%), #fff",
        }}
      >
        {() => (
          <>
            <ModalHeader className="relative min-h-[72px]">
              <div className="absolute top-0 left-0 flex w-full items-center justify-center">
                <div className="-translate-y-1/2">
                  <Image
                    src={extension}
                    alt="extension"
                    className="pointer-events-none h-20 w-auto"
                  />
                </div>
              </div>
            </ModalHeader>
            <ModalBody className="px-6 py-0">
              <div className="flex flex-col gap-4">
                <div>
                  <h2 className="text-center text-[20px] leading-[20px] font-bold sm:text-[28px] sm:leading-[28px]">
                    Instant Lowest Prices with AI
                  </h2>
                  <h2 className="text-center text-[20px] font-bold text-[#0F9E4F] sm:text-[28px]">
                    “ New Users Get $5! ”
                  </h2>
                  <p className="mt-3 text-center sm:px-[46px]">
                    Get the lowest prices in seconds — plus $5 free for new
                    users!
                  </p>
                </div>
                <div className="hidden justify-center sm:flex">
                  <Image
                    src={extensionmodalimg}
                    alt="extensionmodalimg"
                    width={143}
                    height={110}
                  />
                </div>
                <div className="flex justify-center sm:hidden">
                  <Image
                    src={extensionmobile}
                    alt="extensionmobile"
                    width={113}
                    height={88}
                  />
                </div>
                <GoogleStoreLink>
                  <Button
                    fullWidth
                    className="h-[44px] rounded-[49px] bg-black font-bold text-white sm:h-[52px]"
                    onPress={handleClose}
                    style={{
                      backgroundImage:
                        "linear-gradient(to right, #4cbc37, #0F9e4f)",
                    }}
                  >
                    Add to Chrome & Get $5 Free
                  </Button>
                </GoogleStoreLink>
                <div className="flex h-4 flex-row items-center justify-center gap-1">
                  <div className="flex flex-row items-center justify-center">
                    {Array.from({ length: 3 }).map((_, index) => (
                      <Avatar
                        key={index}
                        src={[
                          "https://i.pravatar.cc/150?u=a04258a2462d826712d",
                          "https://i.pravatar.cc/150?u=a042581f4e29026704d",
                          "https://i.pravatar.cc/150?u=a04258114e29026302d",
                        ].at(index)}
                        classNames={{
                          base: `size-4 border-[0.6px] border-white border-solid ${
                            index === 0 ? "" : "-ml-[3px]"
                          }`,
                        }}
                      />
                    ))}
                  </div>
                  <p className="text-center text-[14px] font-bold text-[#4E5969]">
                    10000+ users, Chrome web store
                  </p>
                </div>
                <div className="flex flex-row items-center justify-center gap-1">
                  {Array.from({ length: 4 }).map((_, index) => (
                    <Image
                      key={index}
                      src={star}
                      alt="star"
                      width={20}
                      height={20}
                    />
                  ))}
                  <Image src={halfstar} alt="halfstar" width={20} height={20} />
                </div>
                <div
                  onClick={handleClose}
                  className="cursor-pointer text-center text-[12px] text-[#4E5969]"
                >
                  Add extension later
                </div>
              </div>
            </ModalBody>
            <ModalFooter className="min-h-[24px]"></ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}
